<template>
  <v-dialog v-model="showDialog" max-width="640" scrollable>
    <v-card>
      <v-card-title class="d-flex">
        Daily Check Detail
        <v-spacer></v-spacer>
        <v-btn icon @click="showDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="loading" class="text-center py-8">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-card-text>
      <v-card-text v-else-if="check">
        <v-row dense>
          <v-col cols="12" sm="4">
            <p class="caption grey--text mb-0">Date</p>
            <p>{{ check.check_date }}</p>
          </v-col>
          <v-col cols="12" sm="4" v-if="check.checked_by">
            <p class="caption grey--text mb-0">Checked By</p>
            <p>{{ check.checked_by.full_name || check.checked_by.username }}</p>
          </v-col>
          <v-col cols="12" sm="4" v-if="check.branch">
            <p class="caption grey--text mb-0">Branch</p>
            <p>{{ check.branch.branch_name }}</p>
          </v-col>
        </v-row>
        <v-simple-table class="mt-2">
          <template v-slot:default>
            <thead>
              <tr>
                <th>Checklist Item</th>
                <th class="text-center">Result</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in housekeepingItems" :key="item.id">
                <td>{{ item.label }}</td>
                <td class="text-center">
                  <v-icon :color="item.checked ? 'green' : 'red'" small>
                    {{ item.checked ? "mdi-check-circle" : "mdi-close-circle" }}
                  </v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <template v-if="securityItems.length">
          <v-divider class="my-3"></v-divider>
          <p class="subtitle-2 mb-2">Security &amp; Systems</p>
          <v-row dense>
            <v-col
              v-for="item in securityItems"
              :key="item.id"
              cols="12"
              sm="4"
            >
              <v-icon :color="item.checked ? 'green' : 'red'" small>
                {{ item.checked ? "mdi-check-circle" : "mdi-close-circle" }}
              </v-icon>
              {{ item.label }}
            </v-col>
          </v-row>
        </template>

        <template v-if="check.notes">
          <p class="caption grey--text mb-0 mt-4">Notes</p>
          <p>{{ check.notes }}</p>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["show", "checkId"],
  computed: {
    ...mapGetters({ hasPermission: "permission/hasPermission" }),
    housekeepingItems() {
      return this.check
        ? (this.check.items || []).filter((i) => i.section !== "security")
        : [];
    },
    securityItems() {
      return this.check
        ? (this.check.items || []).filter((i) => i.section === "security")
        : [];
    },
    showDialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  data() {
    return {
      loading: false,
      check: null,
    };
  },
  watch: {
    show(value) {
      if (value && this.checkId) this.load();
    },
  },
  methods: {
    ...mapActions({
      get_daily_check: "facilities/get_daily_check",
    }),
    can(key) {
      return this.hasPermission(key);
    },
    async load() {
      this.loading = true;
      this.check = null;
      try {
        this.check = await this.get_daily_check(this.checkId);
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
  },
};
</script>
